<template>
  <div :class="[
    'flex items-center',
    `bg-${icon}`, 
    `size-${size}`, 
    `pointer-events-${pointerEvents}`
  ]"><slot /></div>
</template>

<script>
export default {
  name: 'GrmIcon',
  props: {
    icon: {type: String, required: true},
    size: {type: String, default: 'md'},
    pointerEvents: {type: String, default: 'none'},
  }
}
</script>

<style lang="scss" scoped>
.size- {
  &md { @apply w-4 h-4 }
  &lg { @apply w-6 h-6 }
  &2xl { @apply w-8 h-8 }
  &full { @apply w-full h-full }
}
</style>